var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.076 4.47h-6.267c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748c-.436.855-.436 1.975-.436 4.216v11.2c0 2.24 0 3.36.436 4.215a4 4 0 0 0 1.748 1.749c.856.436 1.976.436 4.216.436h12.267c1.24 0 1.86 0 2.369-.137a4 4 0 0 0 2.828-2.828c.136-.509.136-1.129.136-2.369m-2.666-12v-8m-4 4h8m-15.334 4.667a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0zm5.987 4.557L9.117 26.614c-.634.576-.951.865-.98 1.114a.667.667 0 0 0 .223.576c.189.166.618.166 1.475.166H22.35c1.92 0 2.879 0 3.632-.323a4 4 0 0 0 2.105-2.104c.322-.754.322-1.713.322-3.632 0-.646 0-.969-.07-1.27a2.666 2.666 0 0 0-.499-1.036c-.19-.243-.443-.445-.947-.848l-3.73-2.984c-.504-.404-.756-.605-1.034-.677a1.333 1.333 0 0 0-.743.024c-.273.088-.512.306-.99.74z",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlus);
export default __webpack_public_path__ + "static/media/image-plus.d3be6c65df755478cfd52296b3e67b33.svg";
export { ForwardRef as ReactComponent };